import React, { useState } from "react";
import * as S from "./CreateReceiptModalStyle";
import { receiptService } from "../../Services/receiptService"; // Criar este serviço abaixo

export default function CreateReceiptModal({
  contractId,
  clientId,
  onClose,
  onSuccess,
}) {
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!file || !description) {
      alert("Por favor, preencha a descrição e selecione um arquivo.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("clientId", clientId);
    formData.append("contractId", contractId);
    formData.append("description", description);
    formData.append("file", file);

    try {
      await receiptService.createContractReceipt(formData);
      alert("Recibo enviado com sucesso!");
      onSuccess();
      onClose();
    } catch (error) {
      console.error(error);
      alert("Erro ao enviar recibo. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.Overlay>
      <S.ModalContainer>
        <S.Header>
          <h3>Anexar Comprovante</h3>
          <S.CloseButton onClick={onClose}>&times;</S.CloseButton>
        </S.Header>
        <S.Content>
          <label>Descrição</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Ex: Comprovante de pagamento do contrato..."
          />

          <label>Arquivo (PDF ou Imagem)</label>
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={(e) => setFile(e.target.files[0])}
          />
        </S.Content>
        <S.Footer>
          <S.Button className="cancel" onClick={onClose}>
            Cancelar
          </S.Button>
          <S.Button className="save" onClick={handleSubmit} disabled={loading}>
            {loading ? "Enviando..." : "Enviar Recibo"}
          </S.Button>
        </S.Footer>
      </S.ModalContainer>
    </S.Overlay>
  );
}
